import FinancialDashboard from './FinancialDashboard';

function App() {
  
return (
    <div className="App">
	<FinancialDashboard />
    </div>
  )
}

export default App;
